module.exports = __webpack_public_path__ + "img/edit.00dbdba5.svg";